import { ReactNode } from "react";
import { TableCell, TableRow } from "@mui/material";

import { TableItemsNotFound } from "ui/data-grid/components/table-items-not-found/table-items-not-found";

type TableEmptyStateProps = {
  colSpan: number;
  message?: string;
  state?: ReactNode;
};

export const TableEmptyState = ({ colSpan, message = "No data", state }: TableEmptyStateProps) => (
  <TableRow>
    <TableCell colSpan={colSpan} align="center" sx={{ py: 6 }}>
      {state ?? <TableItemsNotFound message={message} />}
    </TableCell>
  </TableRow>
);
